

import React, { useState, useEffect } from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ModificationProductionModal from "./ModificationProductionModal";
import POStatusModal from "./POStatusModal";
import config from "../../config/config";
import axios from "axios";
import Loader from "../loader/Loader";
import { getAuthToken } from "../../utils/token";

const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa', // optional light background
    },
  },
};

const MonthlyProductionBoardModal = ({ show, handleClose }) => {
  const [modificationProduction, setModificationProduction] = useState(false);
  const [pOStatus, setPOStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [monthlyproductionplanningboard, setMonthlyproductionplanningboard] = useState([]);

  const monthlyproductionplanning = async () => {
    const token = getAuthToken();
    if (!token) return;

    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/manager/monthlyproductionplanningboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = response?.data?.plans || [];
      setMonthlyproductionplanningboard(result);
    } catch (err) {
      console.error("Error fetchProductionplan:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    monthlyproductionplanning();
  }, []);

  // Define columns for DataTable
  const columns = [
    { name: "MONTH", selector: row => row.month, sortable: true },
    { name: "PRODUCT", selector: row => row?.product?.name, sortable: true },
    {
      name: "PLANNED",
      selector: row =>
        Number(row?.qty_produced || 0) + Number(row?.qty_pending || 0),
      sortable: true,
    },
    { name: "ACTUAL", selector: row => row?.qty_produced, sortable: true },
    { name: "PENDING", selector: row => row?.qty_pending, sortable: true },
    {
      name: "STATUS",
      cell: row => {
        const status = row?.purchase_order?.delivery_status;
        return (
          <Badge
            bg={
              status === "Completed"
                ? "success-subtle"
                : status === "In Progress"
                  ? "primary-subtle"
                  : "secondary-subtle"
            }
            text={
              status === "Completed"
                ? "success"
                : status === "In Progress"
                  ? "primary"
                  : "secondary"
            }
            className="px-3 py-2"
          >
            {status}
          </Badge>
        );
      },
      sortable: true,
    },
  ];

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        centered
        className="font_family"
      >
        <div className="p-3 p-md-5">
          <Modal.Header closeButton className="flex-wrap gap-2">
            <strong className="fs-5 fs-md-4">
              Monthly Production Planning Board
            </strong>
          </Modal.Header>

          <Modal.Body>
            {loading ? (
              <Loader />
            ) : (
              <DataTable
                columns={columns}
                customStyles={customStyles}
                data={monthlyproductionplanningboard}
                pagination
                highlightOnHover
                responsive
                dense
                defaultSortField="month"
                noHeader
              />
            )}

            <div className="text-end mt-4">
              <Button
                variant="dark"
                onClick={() => setModificationProduction(true)}
              >
                Modify Plan
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* Nested Modals */}
      <ModificationProductionModal
        show={modificationProduction}
        handleClose={() => setModificationProduction(false)}
        refreshParent={monthlyproductionplanning}
      />
      <POStatusModal show={pOStatus} handleClose={() => setPOStatus(false)} />
    </>
  );
};

export default MonthlyProductionBoardModal;
